import { Modal, Alert } from "antd"
import { useModalContext } from "../../context/ModalContext"
import { useCallback } from "react"

function MessageModal() {
    const { modalMessage, modalDescription, modalType, resetModalContext } = useModalContext()

    const onClose = useCallback(() => {
        resetModalContext()
    }, [resetModalContext])

    return(
        <Modal
            open={true}
            onCancel={onClose}
            footer={null}
        >
            <Alert
                message={modalMessage}
                description={modalDescription}
                type={modalType}
                showIcon
            />
        </Modal>
    )
}

export default MessageModal